export default __webpack_public_path__ + "static/media/fad-eraser.2b6b6554.svg";